import { Component, inject, OnInit } from '@angular/core'
import { PageComponent } from '@client/Components/ui/Page/Page.Component'
import Order from '@client/Order'
import { PaymentPlan } from '@client/PaymentPlan'
import { ActivatedRoute, Params } from '@angular/router'
import { Table } from '@ui/Table'
import HttpError from '@ui/HttpError'
import { OrdersService } from '@client/Services/OrdersService'
import { CardComponent } from '@ui/Components/Card/Card.Component'
import { CardContentComponent } from '@ui/Components/Card/CardContent.Component'
import {
	CdkTableComponent,
	CdkTableFooter,
} from '@ui/Components/Table/CdkTable.Component'
import { PaymentPlanInstalment } from '@client/PaymentPlanInstalment'
import { SystemConfigService } from '@client/Services/SystemConfigService'
import { formatCurrency } from '@ui/utils'
import { RaisedButtonComponent } from '@ui/Components/Form/Button/RaisedButton.Component'
import { Location } from '@angular/common'

@Component({
	selector: 'gocardless-payment-plan',
	templateUrl: './PaymentPlan.Component.html',
	imports: [
		PageComponent,
		CardComponent,
		CardContentComponent,
		CdkTableComponent,
		RaisedButtonComponent,
	],
})
export class PaymentPlanComponent
	extends Table<PaymentPlanInstalment>
	implements OnInit
{
	public displayColumns: string[] = ['id', 'due_date', 'amount']

	protected order: Order

	protected paymentPlan: PaymentPlan

	protected footer: CdkTableFooter<PaymentPlanInstalment>

	private readonly route: ActivatedRoute

	private readonly ordersService: OrdersService

	private readonly systemConfigService: SystemConfigService

	private readonly location: Location

	constructor() {
		super()
		this.route = inject(ActivatedRoute)
		this.ordersService = inject(OrdersService)
		this.systemConfigService = inject(SystemConfigService)
		this.location = inject(Location)
	}

	public ngOnInit() {
		this.route.params.subscribe(async (params: Params): Promise<void> => {
			await this.fetchOrder(
				parseInt(params.id, 10),
				parseInt(params.planId, 10),
			)
		})
	}

	protected readonly back = async () => {
		await this.location.back()
	}

	private readonly fetchOrder = async (id: number, planId: number) => {
		try {
			this.order = await this.ordersService.findById(id)

			this.tableEntities = [
				{
					columnDef: 'id',
					header: 'ID',
					accessorKey: 'id',
				},
				{
					columnDef: 'due_date',
					header: 'Due Date',
					accessorKey: 'due_date',
					type: 'date',
				},
				{
					columnDef: 'amount',
					header: 'Amount',
					accessorKey: 'amount',
					type: 'currency',
					currency: {
						currency: this.order.currency,
						locale: this.systemConfigService.config.locale,
						currencyPrecision: this.order.currency_precision,
					},
				},
			]

			this.paymentPlan = this.order.payment_plans.find(
				(p: PaymentPlan): boolean => p.id === planId,
			)

			this.footer = {
				label: 'Total',
				value: formatCurrency(
					this.paymentPlan.total_amount,
					this.order.currency,
					this.systemConfigService.config.locale,
					this.order.currency_precision,
				),
			}

			this.setTableData(this.paymentPlan.instalments)
		} catch (error) {
			if (!(error instanceof HttpError)) {
				throw error
			}
		}
	}
}
